import React, { useState, useEffect } from "react";
import Response_Processing from "../../layout/Others/Response_Processing";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import { useMyContext } from "../../components/Provider/CommonProvider";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../components/CommonComponents/MessageBox";
import { Link } from "react-router-dom";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from 'react-icons/io5';
import { IconDeleteFigma, IconEditFigma } from "../../Assets/MyIcons";
import AdminTooltip from "../../components/CommonComponents/AdminTooltip";
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../components/CommonMethod/CommonMethods";

const stripHtml = (html) => html ? html.replace(/<[^>]*>?/gm, '') : '';
const truncate = (str, maxLen) => str?.length > maxLen ? str.substring(0, maxLen - 3) + '...' : str;

const PushNotificationList = () => {
    const baseURL = process.env.REACT_APP_Baseurl;
    const { fetchRequest, infoBoxModelClose } = useMyContext();
    const [notifications, setNotifications] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false);
    const [filter, setFilter] = useState('');
    const [itemDelete, setItemDelete] = useState([]);
    const [modalClose, setModelClose] = useState(false);
    const [selectAllData, setSelectAllData] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);

    const fetchData = async (type) => {
        setShowOverlay(true);
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${baseURL}/admin/push-notification-messages/index`,
                infoBoxModelClose
            });
            if (response?.status) {
                const updatedList = response.data || [];
                setNotifications(updatedList);
                setFilteredData(updatedList);
                if (type === "CSV") await donwloadCSV(updatedList, "PUSH-NOTIFICATIONS");
                if (type === "PDF") await downloadPDF(updatedList, "PUSH-NOTIFICATIONS", ["S.NO", "ID", "TITLE", "DESCRIPTION"]);
                if (type === "XLSX") await downloadXLSX(updatedList, "PUSH-NOTIFICATIONS", ["S.NO", "ID", "TITLE", "DESCRIPTION"]);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to fetch notifications");
        } finally {
            setShowOverlay(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [withOutRefresh]);

    const handleFilter = (event) => {
        const searchTerm = event.target.value.toLowerCase().trim();
        setFilter(searchTerm);
        if (searchTerm === '') {
            setFilteredData(notifications);
            return;
        }
        const filteredResults = notifications?.filter((item) =>
            ["id", "title", "description"].some((property) => {
                const value = item[property];
                return value?.toString().toLowerCase().includes(searchTerm);
            })
        );
        setFilteredData(filteredResults);
    };

    const handleClear = () => {
        setFilter('');
        setFilteredData(notifications);
    };

    const handleSelectAllData = () => {
        setSelectAllData(!selectAllData);
        setItemDelete(selectAllData ? [] : filteredData?.map((item) => item?.id));
    };

    const handleSingleFile = (itemId) => {
        if (itemDelete?.includes(itemId)) {
            setItemDelete(itemDelete?.filter((id) => id !== itemId));
        } else {
            setItemDelete([...itemDelete, itemId]);
        }
    };

    const handleDelete = async () => {
        setShowOverlay(true);
        setModelClose(false);
        try {
            const response = await fetchRequest({
                method: 'DELETE',
                url: `${baseURL}/admin/push-notification-messages/multi-delete`,
                data: { id: [...itemDelete] },
            });
            if (response?.status) {
                toast.success(response.message);
                setWithOutRefresh(!withOutRefresh);
                setSelectAllData(false);
                setItemDelete([]);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || "Delete failed");
        } finally {
            setShowOverlay(false);
        }
    };

    const singleDelete = (id) => {
        setItemDelete([id]);
        setModelClose(true);
    };

    const handleOpenDeleteModal = () => {
        if (itemDelete.length > 0) setModelClose(true);
    };

    const closeModal = () => {
        setModelClose(false);
        setItemDelete([]);
    };

    return (
        <>
            {showOverlay && <Response_Processing />}
            {modalClose && (
                <AdminDeleteModal
                    modelClose={modalClose}
                    deleteClose={closeModal}
                    deleteAction={handleDelete}
                    buttonText={itemDelete?.length}
                />
            )}
            <AdminNavbar
                heading={'Push Notification Management'}
                totalDataLength={filteredData?.length}
                deleteCount={itemDelete?.length}
                navigation={'/add-push-notification'}
                deleteMethod={handleOpenDeleteModal}
                navText={'Add Notification'}
            />

            <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
                    <div className="filterContainer">
                        <input
                            type='text'
                            placeholder="Search"
                            className="filter form-control theme-text-color theme-bg-color theme-border-secondary"
                            value={filter}
                            onChange={(event) => handleFilter(event)}
                        />
                        {filter?.length > 0 && (
                            <button type="button" className="clearBtn" onClick={() => handleClear()}>
                                <IoClose className="custom-close-btn" />
                            </button>
                        )}
                    </div>
                    <div className='d-flex align-items-center'>
                        <button
                            className="custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 border border-2 rounded-circle theme-border-color"
                            onClick={() => setWithOutRefresh(!withOutRefresh)}
                        >
                            <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                            <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                        </button>
                        <div className="dropdown d-block ms-2">
                            <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="fw-bolder text-white">Export All</span>
                                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                            </button>
                            <ul className="dropdown-menu theme-bg-color">
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("CSV")}>CSV</li>
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("PDF")}>PDF</li>
                                <li className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("XLSX")}>XLSX</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="">
                    <div className="d-flex flex-wrap theme-border-bottom-secondary pb-3">
                        <div className="rowCheckboxDrag d-flex justify-content-end col-1 p-2">
                            <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /></label>
                        </div>
                        <div className="col-2 p-2"><label className="theme-text-color fw-bold d-flex justify-content-center fs-6">Image</label></div>
                        <div className="col-2 p-2"><label className="theme-text-color fw-bold fs-6">Title</label></div>
                        <div className="col-3 p-2"><label className="theme-text-color fw-bold fs-6">Description</label></div>
                        <div className="col-1 p-2"><label className="theme-text-color fw-bold fs-6">Status</label></div>
                        <div className="col-2 p-2"><label className="theme-text-color fw-bold fs-6">URL</label></div>
                        <div className="col-2 p-2"><label className="theme-text-color fw-bold fs-6">Actions</label></div>
                    </div>

                    <ul className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
                        {loading ? (
                            <NoRecordTable result={filteredData?.length} loader={true} />
                        ) : filteredData.length ? (
                            filteredData.map((item, index) => (
                                <li key={item.id} className="theme-bg-color theme-text-color w-100 theme-border-bottom-secondary px-3 py-2">
                                    <div className="d-flex align-items-center">
                                        <div className="rowCheckboxDrag col-1 justify-content-start">
                                            <input
                                                type="checkbox"
                                                checked={itemDelete?.includes(item.id)}
                                                onChange={() => handleSingleFile(item.id)}
                                            />
                                        </div>
                                        <div className="col-2 text-center">
                                            {item.image ? (
                                                <img
                                                    src={item.image}
                                                    className="profile rounded"
                                                    alt={item.title}
                                                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <div className="bg-light rounded d-inline-block" style={{ width: '50px', height: '50px' }}></div>
                                            )}
                                        </div>
                                        <div className="col-2 text-center">
                                            <MessageBox text={item.title} classname="admin-input-title" loadingHide />
                                        </div>
                                        <div className="col-3">
                                            <span className="dateText table-subheading">
                                            </span>
                                        </div>
                                        <div className="col-1">
                                            {item.publish_type === 'publish_now' || item.sent_status === 1 ? (
                                                <span className="badge bg-success">Sent</span>
                                            ) : (
                                                <div className="d-flex flex-column">
                                                    <span className="badge bg-warning text-dark">Scheduled</span>
                                                    {item.publish_time && (
                                                        <small className="text-muted mt-1" style={{ fontSize: '10px' }}>
                                                            {new Date(item.publish_time).toLocaleString()}
                                                        </small>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-2">
                                            <span className="dateText table-subheading">
                                                {truncate(
                                                    item.url_type === 'site_url'
                                                        ? `${process.env.REACT_APP_Baseurl_Frontend || ''}/${item.url || ''}`
                                                        : (item.url || '-'),
                                                    30
                                                )}
                                            </span>
                                        </div>
                                        <div className="col-2">
                                            <div className="editdropdown">
                                                <span className="editdropdown-button">
                                                    <FaEllipsisVertical className="theme-text-color" />
                                                </span>
                                                <div className="editdropdown-menu theme-bg-color">
                                                    <Link to={`/edit-push-notification/${item.id}`} className="theme-text-color theme-bg-color">
                                                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                        <MessageBox text="Edit" classname='ms-2 theme-text-color' />
                                                    </Link>
                                                    <div onClick={() => singleDelete(item.id)} className="commonActionPadding theme-bg-color cursor-pointer">
                                                        <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                                        <MessageBox text="Delete" classname='ms-2 theme-text-color' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))
                        ) : (
                            <NoRecordTable result={filteredData?.length} loader={false} />
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default PushNotificationList;
